import React from 'react';

import moment from 'moment';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Page from 'components/page/page.component';

import { HistoryEvents } from './history-events';

import './style.css';

const History = () => {
    const Event = ({ timestamp, description }) => {
        return (
            <Row key={`history-event-row-${timestamp}`} className="history-event">
                <Col />
                <Col xs={12} md={6} className="history-event-details">
                    <h4>{timestamp}</h4>
                    <p>{description}</p>
                </Col>
                <Col />
            </Row>
        );
    };

    const sortedEvents =
        HistoryEvents?.sort((a, b) => {
            const dateA = moment(a.timestamp);
            const dateB = moment(b.timestamp);
            return dateA.unix() > dateB.unix() ? -1 : 1;
        }) ?? [];

    return (
        <Page
            className="history-events"
            heroTitle="History"
            heroText="Below is a list of significant events for the Muncie Land Bank"
            heroSize="small"
        >
            <Container>
                {sortedEvents && sortedEvents.map((h) => <Event key={`history-event-${h.timestamp}`} {...h} />)}
            </Container>
        </Page>
    );
};

export default History;
